import app from 'flarum/common/app';
const base = () => app.forum.attribute('apiUrl') + '/shutter';
export function api(method, path, body, params) {
  return app.request({
    method,
    url: base() + path,
    body: body,
    params: params
  });
}
export const t = (key, params = {}) => app.translator.trans(`ernestdefoe-shutter.forum.${key}`, params);

/** 1st, 2nd, 3rd, 4th… in the forum's language. */
export function place(n) {
  return app.translator.trans(`ernestdefoe-shutter.lib.place.${Math.min(n, 4)}`, {
    n
  });
}

/** "in 3 days", "2 hours ago" — the browser's own wording for the forum's locale. */
export function relative(iso) {
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  const units = [['day', 86400], ['hour', 3600], ['minute', 60]];
  const rtf = new Intl.RelativeTimeFormat(app.translator.getLocale() || undefined, {
    numeric: 'auto'
  });
  for (const [unit, secs] of units) {
    if (Math.abs(diff) >= secs) return rtf.format(Math.round(diff / secs), unit);
  }
  return rtf.format(Math.round(diff), 'second');
}
export function when(iso) {
  return new Date(iso).toLocaleString(app.translator.getLocale() || undefined, {
    dateStyle: 'medium',
    timeStyle: 'short'
  });
}
flarum.reg.add('ernestdefoe-shutter', 'common/api', { api: api,t: t,place: place,relative: relative,when: when, });